import { render, staticRenderFns } from "./_salesdata-card.vue?vue&type=template&id=ab3c28c4&scoped=true&"
import script from "./_salesdata-card.vue?vue&type=script&lang=js&"
export * from "./_salesdata-card.vue?vue&type=script&lang=js&"
import style0 from "./_salesdata-card.vue?vue&type=style&index=0&id=ab3c28c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3c28c4",
  null
  
)

export default component.exports